import apiClient from './client';
import type { Domain, CreateDomainInput, UpdateDomainInput } from '@/types/domain';
import { getSelectedNetwork } from '@/lib/gamNetwork';

// ========== DOMAINS API ==========

// Lista os domínios da conta GAM selecionada no topo do painel. Todas as telas
// que listam domínios passam por aqui, então todas respeitam o seletor.
// Sem parâmetro de propósito: várias telas passam `queryFn: getDomains` direto,
// e o react-query chamaria com o contexto da query no primeiro argumento.
export const getDomains = async (): Promise<Domain[]> => {
    const network = getSelectedNetwork();
    const response = await apiClient.get<Domain[]>('/domains', {
        params: network ? { network } : undefined,
    });
    return response.data;
};

// Todos os domínios, de todas as contas. Só para dar NOME a registro que vem
// de outro serviço pelo domain_id (estrutura de preço, cascatas): esses
// registros não seguem o seletor, e com a outra conta selecionada o nome
// sumia e virava "#id". Para listas de escolha, use getDomains.
export const getAllDomains = async (): Promise<Domain[]> => {
    const response = await apiClient.get<Domain[]>('/domains');
    return response.data;
};

// Criar novo domínio
export const createDomain = async (data: CreateDomainInput): Promise<Domain> => {
    const response = await apiClient.post<Domain>('/domains', data);
    return response.data;
};

// Atualizar domínio
export const updateDomain = async (domainId: number, data: UpdateDomainInput): Promise<Domain> => {
    const response = await apiClient.put<Domain>(`/domains/${domainId}`, data);
    return response.data;
};

export interface TrocaDeContaResult {
    domain: Domain;
    from_network: string;
    to_network: string;
    detached_blocks: number;
    detached_root: boolean;
}

// Trocar a conta GAM (só admin). A API recusa com 409 se houver bloco ativo e
// desvincula os blocos arquivados da conta antiga para "Gerar blocos" criar do zero.
export const changeDomainNetwork = async (domainId: number, network: string): Promise<TrocaDeContaResult> => {
    const response = await apiClient.post<TrocaDeContaResult>(`/domains/${domainId}/change-network`, { network });
    return response.data;
};

// Deletar domínio (soft delete)
export const deleteDomain = async (domainId: number): Promise<void> => {
    await apiClient.delete(`/domains/${domainId}`);
};

// Verificar disponibilidade de domínio
export const checkDomainAvailability = async (domainName: string): Promise<{ available: boolean; message: string }> => {
    const response = await apiClient.get<{ available: boolean; message: string }>(`/domains/check/${domainName}`);
    return response.data;
};

export async function getPreviewHtml(domain: string) {
    const response = await apiClient.post('/domains/preview', {
        domain: domain
    });
    return response.data;
}

